import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.languageAndFormats.edit.header.title' }),
    headerDescription: translate({ id: 'settings.languageAndFormats.edit.header.description' }),
    save: translate({ id: 'settings.rmAccount.edit.footer.save' }),
    cancel: translate({ id: 'settings.rmAccount.edit.footer.cancel' }),
  }))

  return api
}
